export * from './http.resource/http.resource';
export * from './identity.resource/identity.resource';



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./public/app/resources/index.ts